import * as Types from '../constants/actionTypes';
const defaultState = {
    isPending: false,
    boxesList: [],
    error: ''
}
export default (state = defaultState, action) => {
    switch (action.type) {
        /* Box Details States */
        case Types.USER_LOCATION_DETAILS_SUCCESS:
            return {
                ...state,
                userLocationDetails: action.data,
            }
        case Types.USER_LOCATION_DETAILS_FAILED:
            return {
                ...state,
                userLocationDetailsErr: action.err,
            }
        case Types.COUNTRY_DATA_SUCCESS:
            return {
                ...state,
                countryData: action.payload
            }
        case Types.COUNTRY_DATA_ERROR:
            return {
                ...state,
                countryDataErr: action.payload
            }
        default:
            return state
    }
}
